import { useTranslation } from 'react-i18next';
import { ScreenBackdrop } from './ScreenBackdrop';
import { ChevronRight } from './icons';
import messageIcon from '../../assets/figma/profile/message.svg';
import { useBackButton, hasTelegramBackButton } from '../../hooks/useBackButton';

export function SupportScreen({
  email,
  telegram,
  onClose,
}: {
  email: string;
  telegram: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  useBackButton(onClose);
  const tgBack = hasTelegramBackButton();

  const Card = ({
    icon,
    title,
    subtitle,
    onClick,
    href,
  }: {
    icon: string;
    title: string;
    subtitle: string;
    onClick?: () => void;
    href?: string;
  }) => {
    const inner = (
      <>
        <span className="flex h-11 w-11 items-center justify-center rounded-[14px] bg-[#f1f2f4]">
          <img src={icon} alt="" className="h-5 w-5 brightness-0" />
        </span>
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="text-[15px] font-medium text-ink">{title}</span>
          <span className="truncate text-[13px] text-muted">{subtitle}</span>
        </span>
        <ChevronRight size={18} className="text-muted" />
      </>
    );
    const cls =
      'flex w-full items-center gap-3 rounded-[20px] bg-white p-4 text-left shadow-card active:opacity-70';
    return href ? (
      <a href={href} className={cls}>
        {inner}
      </a>
    ) : (
      <button onClick={onClick} className={cls}>
        {inner}
      </button>
    );
  };

  return (
    <div className="relative flex min-h-screen flex-col bg-surface">
      <ScreenBackdrop height={300} fadeStart={24} />
      <div className="relative z-10 flex min-h-screen flex-col px-4 pb-10 pt-[calc(var(--tg-safe-top)_+_0.75rem)]">
        <header className="flex items-center gap-3 py-2">
          {!tgBack && (
            <button
              onClick={onClose}
              className="flex h-8 w-8 items-center justify-center rounded-full bg-black/[0.06]"
              aria-label="Back"
            >
              <ChevronRight size={16} className="rotate-180 text-ink" />
            </button>
          )}
          <h1 className="text-[20px] font-medium text-ink">{t('profile.support')}</h1>
        </header>

        <p className="mt-1 mb-4 text-[13px] text-muted">{t('profile.supportHint')}</p>

        <div className="flex flex-col gap-3">
          <Card
            icon={messageIcon}
            title={t('profile.supportChat')}
            subtitle={t('profile.supportChatDesc')}
            onClick={() => window.Telegram?.WebApp?.openTelegramLink(telegram)}
          />
          <Card
            icon={messageIcon}
            title={t('profile.supportEmail')}
            subtitle={email}
            href={`mailto:${email}`}
          />
        </div>
      </div>
    </div>
  );
}
